import styled from "@emotion/styled";

import { DropdownMenu, DropdownMenuItem, DropdownMenuTrigger } from "components/ui/dropdown_menu";
import { useSubscription } from "lib/hooks/subscription";
import { Flex } from "../../styles/utility-components";
import { AllEntities, entityToDataType } from "./utils";

type EntityCardProps = {
  header?: React.ReactNode;
  entity: AllEntities;
  children: React.ReactNode;
  cta?: React.ReactNode;
  removeEntity: () => void;
};

export default function EntityCardContent({
  header,
  entity,
  removeEntity,
  children,
  cta,
}: EntityCardProps) {
  const subscription = useSubscription();
  const hasAccess = subscription.hasDataTypes(entityToDataType(entity));

  return (
    <Container column gap={16}>
      <Flex justifyContent="space-between" gap={16}>
        {header && <Flex>{header}</Flex>}
        <Flex gap={8}>
          {cta}
          {hasAccess && (
            <DropdownMenu
              trigger={
                <StyledDropdownMenuTrigger
                  buttonStyle="inverse"
                  buttonType="primary"
                  icon="dotsVertical"
                  aria-label="Entity actions"
                  hideArrow
                />
              }
              width={129}
            >
              <DropdownMenuItem
                key="unsave"
                icon="bookmark"
                iconProps={{
                  fill: "none",
                }}
                onClick={(e: React.MouseEvent) => {
                  e.stopPropagation();
                  removeEntity();
                }}
              >
                Unsave
              </DropdownMenuItem>
            </DropdownMenu>
          )}
        </Flex>
      </Flex>
      {children}
    </Container>
  );
}

const Container = styled(Flex)({
  width: "100%",
  justifyContent: "space-between",
});

const StyledDropdownMenuTrigger = styled(DropdownMenuTrigger)({
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "transparent",
  },
});
